import { SilverwareForkIcon } from './SilverwareForkIcon';

/**
 * author: Austin Andrews
 * id 7B00A99C-3766-4939-993F-657333EE430B
 * name silverware-fork
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-fork.svg
 * tags
 * - Food / Drink 
 */
export const CutleryForkIcon = SilverwareForkIcon;
export default CutleryForkIcon